module.exports = __webpack_public_path__ + "static/media/histiocytoma100x.ba017c59.jpg";